'use client'
import type { Img } from '../../types/props.js'
import { withLayout } from '../../shared/Styles.js'
import { Picture, Text } from '../../components/index.js'
export type FeaturesDataType = {
  img: Img
  mobileImg: Img
  title: string
  description: string
  numberOne: string
  textOne: string
  numberTwo: string
  textTwo: string
  icon: Img
}
type FeaturesType = React.HTMLAttributes<HTMLDivElement> & {
  data: {
    title: string
    img: Img
    mobileImg: Img
    list: FeaturesDataType[]
  }
}

const Features = (props: FeaturesType) => {
  const { data, className, ...rest } = props
  const { list } = data

  return (
    <>
      <div {...rest} className={className}>
        {data?.title && (
          <div className="desktop:w-[800px] pb-[24px]">
            <Text
              html={data?.title}
              className=" desktop:!text-[32px] lg-desktop:text-lg line-clamp-3 !text-[24px] !leading-[1.2] [&_*_strong]:!font-bold"
            />
          </div>
        )}
        {data?.img?.url && (
          <Picture
            className="md-tablet:hidden aspect-[1664/560] rounded-2xl"
            imgClassName=""
            source={data?.img?.url}
            alt={data?.img?.alt || ''}
          />
        )}
        {data?.mobileImg?.url && (
          <Picture
            className="tablet:hidden aspect-[358/360] rounded-2xl"
            imgClassName=""
            source={data?.mobileImg?.url}
            alt={data?.mobileImg?.alt || ''}
          />
        )}
        <div className="">
          <div className="flex flex-col gap-0">
            {list.map((item, index) => (
              <div
                key={index}
                className={`desktop:flex tablet:gap-8 laptop:gap-[64px] gap-4 pt-[64px] ${index % 2 === 0 ? 'laptop:flex-row-reverse' : ''}`}
              >
                <div className="desktop:w-[500px] lg-desktop:w-[640px] flex shrink-0 flex-col justify-center">
                  <Text
                    html={item?.title}
                    className="graphic-title  desktop:text-[32px] line-clamp-3 text-[24px] leading-[1.2] [&_*_strong]:!font-bold"
                  />
                  <Text
                    html={item?.description}
                    className="graphic-title desktop:pt-[8px] lg-desktop:text-[18px] tablet:max-w-[463px] laptop:max-w-[563px] desktop:max-w-none desktop:text-[16px] pt-[4px] text-[14px] leading-[1.4] [&_*_strong]:!font-bold"
                  />
                  {/* 渐变色 */}
                  {item?.numberOne && (
                    <div className="desktop:pt-[48px] desktop:flex-col desktop:gap-[48px] flex flex-row gap-[24px] pt-[24px]">
                      <div className="">
                        <Text
                          style={{
                            background: 'var(--1, linear-gradient(90deg, #3AD1FF 0%, #008CD6 100%))',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            color: 'transparent', // 建议加上，兼容部分浏览器
                          }}
                          html={item?.numberOne}
                          className="graphic-title desktop:text-[64px] line-clamp-3 text-[40px] leading-none [&_*_strong]:!font-bold"
                        />
                        <Text
                          html={item?.textOne}
                          className="graphic-title lg-desktop:text-lg desktop:text-[18px] line-clamp-3 text-[14px] leading-[1.4] [&_*_strong]:!font-bold"
                        />
                      </div>
                      <div>
                        <Text
                          style={{
                            background: 'var(--1, linear-gradient(90deg, #3AD1FF 0%, #008CD6 100%))',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            color: 'transparent', // 建议加上，兼容部分浏览器
                          }}
                          html={item?.numberTwo}
                          className="graphic-title desktop:text-[64px] line-clamp-3 text-[40px] leading-none [&_*_strong]:!font-bold"
                        />
                        <Text
                          html={item?.textTwo}
                          className="graphic-title lg-desktop:text-lg desktop:text-[18px] line-clamp-3 text-[14px] leading-[1.4] [&_*_strong]:!font-bold"
                        />
                      </div>
                    </div>
                  )}
                  {item?.icon?.url && (
                    <div className="desktop:pt-[24px] lg-desktop:pt-[48px] pt-[24px]">
                      <Picture
                        className="desktop:w-[368px] lg-desktop:w-[488px] w-[358px]"
                        source={item?.icon?.url}
                        alt={item?.icon?.alt || ''}
                      />
                    </div>
                  )}
                </div>
                <div className="md-tablet:hidden laptop:mt-[24px] desktop:pt-0 mt-[24px] aspect-[964/560] overflow-hidden rounded-2xl">
                  <Picture className="size-full object-cover " source={item?.img?.url} alt={item?.img?.alt || ''} />
                </div>
                <div className="tablet:hidden mt-[24px] aspect-[358/360] overflow-hidden rounded-2xl">
                  <Picture
                    className="size-full object-cover"
                    source={item?.mobileImg?.url}
                    alt={item?.mobileImg?.alt || ''}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default withLayout(Features)
